import React, { useEffect, useState } from 'react';
import { BACKEND_URL } from '../../config';

// 📅 Weekly protocol summary: visible from the weekend close until the Monday open.
export const WeeklySummaryCard = () => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/weekly-summary`, { headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` } })
      .then((r) => r.json())
      .then((d) => setSummary(d.summary || null))
      .catch(() => setSummary(null));
  }, []);

  if (!summary) return null;
  const lines = (summary.text || '').split('\n');

  return (
    <div data-testid="weekly-summary-card" style={{ padding: '1.25rem 1.5rem', marginBottom: '1.5rem', borderRadius: '12px', background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)', border: '2px solid #6366f1' }}>
      <h3 data-testid="weekly-summary-title" style={{ fontSize: '1.15rem', color: '#3730a3', marginBottom: '0.75rem' }}>📅 Weekly Protocol Summary</h3>
      <div data-testid="weekly-summary-text" style={{ fontSize: '0.92rem', color: '#1e293b', lineHeight: 1.6 }}>
        {lines.map((l, i) => (
          <div key={i} style={{ paddingLeft: l.startsWith('Reason') ? '1rem' : 0, fontWeight: l.startsWith('V4 P&L') ? 700 : 400 }}>{l}</div>
        ))}
      </div>
      <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.75rem' }}>Shown until the Monday market open (Adelaide time).</div>
    </div>
  );
};
